import { CISO_OASIS_API } from '@/api';
import moment from 'moment';
import config from './weimFlexRampTestsConfigs';

const state = {
  tableData: [],
  tableConfig: config.fields,
  tableExportConfig: {},
};

const actions = {
  async fetchWeimFlexRampTests({ commit }, args) {
    commit('setTableData', []);

    const params = {
      startDate: args.tradeDateRangeSelected[0].format('YYYY-MM-DD'),
      endDate: args.tradeDateRangeSelected[1].format('YYYY-MM-DD'),
      marketType: 'RTM', // as of now, only RTM is supported
      baa: args.balancingAuthorityAreaSelected,
      oasisSnapshotIndicator: args.oasisSnapshotIndicatorSelected,
    };
    try {
      const headers = { Accept: 'application/json' };
      const { data } = await CISO_OASIS_API.get('/ene-eim-flex-ramp-input', { params, headers });
      const flattenData = data.flatMap((row) => {
        const date = moment(row.tradingDate).format('YYYY-MM-DD');
        const map = Object.entries(row.dataTypeToValueMapping);
        return map.map(([dataType, dataValue]) => {
          const d = {
            tradingDate: date,
            tradingHour: row.tradingHour,
            marketType: row.marketType,
            baa: row.baa,
            snapshotIndicator: row.snapshotIndicator,
            rampType: row.rampType,
            testIndicator: row.testIndicator,
            dataType: config.dataTypeNameMapping(dataType),
          };
          if (dataType === 'testStatus') {
            d.value = dataValue === 'PASS' ? 1 : 0;
          } else {
            d.value = dataValue;
          }
          return d;
        });
      });

      commit('setTableData', flattenData);
    } catch {
      this.$notify('Failed to retrieve WEIM Flex Ramp Tests', 'error');
    }
  },
  reset({ commit }) {
    commit('setTableData', []);
    commit('setTableExportConfig', {});
  },
};

const mutations = {
  setTableData(state, value) {
    state.tableData = Object.freeze(value);
  },
  setTableConfig(state, value) {
    state.tableConfig = value;
  },
  setTableExportConfig(state, value) {
    state.tableExportConfig = value;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};